import { render, staticRenderFns } from "./IngredientProductionBase.vue?vue&type=template&id=2dbe25e3&scoped=true"
import script from "./IngredientProductionBase.vue?vue&type=script&lang=js"
export * from "./IngredientProductionBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe25e3",
  null
  
)

export default component.exports